/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TaxType } from './';
import {
    TaxTypeFromJSON,
    TaxTypeFromJSONTyped,
    TaxTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface EligibleTaxesResource
 */
export interface EligibleTaxesResource {
    /**
     * 
     * @type {TaxType}
     * @memberof EligibleTaxesResource
     */
    taxType: TaxType;
    /**
     * 
     * @type {string}
     * @memberof EligibleTaxesResource
     */
    label: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof EligibleTaxesResource
     */
    ratesPercent: Array<number>;
}

/**
 * Check if a given object implements the EligibleTaxesResource interface.
 */
export function instanceOfEligibleTaxesResource(value: object): value is EligibleTaxesResource {
    if (!('taxType' in value) || value['taxType'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('ratesPercent' in value) || value['ratesPercent'] === undefined) return false;
    return true;
}

export function EligibleTaxesResourceFromJSON(json: any): EligibleTaxesResource {
    return EligibleTaxesResourceFromJSONTyped(json, false);
}

export function EligibleTaxesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibleTaxesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'taxType': TaxTypeFromJSON(json['taxType']),
        'label': json['label'],
        'ratesPercent': json['ratesPercent'],
    };
}

export function EligibleTaxesResourceToJSON(value?: EligibleTaxesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'taxType': TaxTypeToJSON(value['taxType']),
        'label': value['label'],
        'ratesPercent': value['ratesPercent'],
    };
}

